var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4977 11.7864H1.96422C1.866 11.7864 1.78564 11.8668 1.78564 11.965V13.3043C1.78564 13.4025 1.866 13.4828 1.96422 13.4828H15.4731L12.2522 17.5677C12.1606 17.6837 12.2432 17.8578 12.3928 17.8578H14.0111C14.1205 17.8578 14.2231 17.8087 14.2923 17.7217L18.0602 12.9427C18.4285 12.4739 18.0959 11.7864 17.4977 11.7864ZM18.0356 6.51856H4.52672L7.7477 2.43373C7.83922 2.31766 7.75663 2.14355 7.60707 2.14355H5.98877C5.87939 2.14355 5.77672 2.19266 5.70752 2.27972L1.93966 7.05873C1.57136 7.52748 1.90395 8.21498 2.49993 8.21498H18.0356C18.1339 8.21498 18.2142 8.13463 18.2142 8.03641V6.69713C18.2142 6.59891 18.1339 6.51856 18.0356 6.51856Z",
    fill: "#8738B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.f36e027d226f108565131c5d5aea40db.svg";
export { ForwardRef as ReactComponent };